import React from "react";
import {
  Container,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { useState, useEffect } from "react";
import axios from "axios";
import { Box } from "@mui/system";

const { REACT_APP_DEBUGGER_SERVER_URL } = process.env;

export default function Question(props) {
  const [singleQuestion, setSingleQuestion] = useState({});

  const { questionID } = props;
  const { questionNumber } = props;

  useEffect(() => {
    async function getQuestion() {
      let question = (typeof questionID === "string") ? questionID : questionID._id
      const res = await axios
        .get(`${REACT_APP_DEBUGGER_SERVER_URL}/question/` + question)
        .catch((error) => {
          console.log(error);
        });
      setSingleQuestion(res.data);
    }
    getQuestion();
  }, [questionID]);

  return (
    <Container
      key={questionID}
      component="main"
      maxWidth="sm"
      sx={{ paddingTop: "4px" }}
    >
      <Accordion elevation={3}>
        <AccordionSummary
          sx={{
            display: "flex",
            "& .MuiAccordionSummary-contentGutters": { margin: "0px" },
            "& .css-nelwl5-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded":
              { minSize: "48px" },
          }}
          expandIcon={<ExpandMoreIcon />}
        >
          <Grid
            sx={{
              display: "flex",
              margin: "2px 0px",
              flexDirection: "row",
              justifyContent: "space-between",
              flex: "auto",
            }}
          >
            <Box>Question {questionNumber}</Box>
            <Box sx={{ padding: "0px 5px" }}>{singleQuestion.name}</Box>
            <></>
          </Grid>
        </AccordionSummary>
        <AccordionDetails sx={{ fontSize: "1em" }}>
          {singleQuestion?.instruction}
          {singleQuestion?.requirements?.map((requirement, i) => (
            <Box key={i + 1} sx={{ fontSize: "0.9em" }}>
              {i + 1}. {requirement}
            </Box>
          ))}
        </AccordionDetails>
      </Accordion>
    </Container>
  );
}
